import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import {
  FormBuilder,
  FormControl,
  FormControlDirective,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { invalid } from "moment";
import { ConfirmationService } from "primeng/api";
import { Message } from "primeng/api";
import { PrimeNGConfig } from "primeng/api";
import { ApiServiceService } from "src/app/api-service.service";
import { AppUtility } from "src/app/interceptor/appUtitlity";
@Component({
  selector: 'app-tool-health-checkup-listing',
  templateUrl: './tool-health-checkup-listing.component.html',
  styleUrls: ['./tool-health-checkup-listing.component.scss']
})
export class ToolHealthCheckupListingComponent {
  @ViewChild('dt2') FilteredData: Table;
  role: any;
  msgs: Message[] = [];
  ToolListData: any[] = [];
  supplierId: any;
  checker1Modal: boolean = false;
  display:boolean=false
  statusstring: String;
  checker1remark: string;
  healthcheckupdetails:any[]=[];
  breadcrumb = [
    {
      title: "Tool health Checkup Details",
      subTitle: "Dashboard",
    },
  ];
  filterval: string;
  toolid: any;
  constructor(
    private route: Router,
    public _apiService: ApiServiceService,
    private confirmationService: ConfirmationService,
    private primengConfig: PrimeNGConfig,
    public _utility: AppUtility,
    private fb: FormBuilder
  ) { }
  ngOnInit(): void {
    // this.showToolHealth = this.route.url == '/toolhealthCheck' ? true : false;
    this.supplierId = this._utility.getLocalStorageDetails();
    this.getToolListData();
    this.role = JSON.parse(localStorage.getItem("UserObject"));
    console.log("role", this.role.roleName);
  }
  getToolListData() {
    this._utility.loader(true)
    this._apiService.gethealthbysupplierid().then((res: any) => {
      if (res.success) {
        this._utility.loader(false)
        this.ToolListData = res.returnValue;
        console.log(this.ToolListData, "error");

      } else {
        this._apiService.showMessage(res.message, "error");
        this._utility.loader(false)
      }
    })
      .catch((error: any) => {
        console.log('api error', error);
        this._apiService.showMessage("Something went wrong. Please try again.", "error");
      })
  }

  sendtohealthcheckup() {
    const selectedItems = this.ToolListData.filter(item => item.selected);
    if (selectedItems.some((item: any) => item.toolhealthGenerated == true)) {
      this._apiService.showMessage("Health Checkup Is Already Generated for The selected tool", "info");
      return
    }
    if (selectedItems?.length) {
      this.route.navigate(['/tool-health-checkup'], {
        state: { packagedata: selectedItems }
      });
    } else {
      this._apiService.showMessage("please select atleast one checkbox", "error",)
    }
  }
  reset(dt2) {
    dt2.reset();
    this.filterval = ''
  }
  onAprrovPress(id: number) {
    console.log(id), "checke";
    this.toolid = id
    console.log(this.toolid);

    this.checker1Modal = true
  }
  btnClick(string) {
    this.statusstring = string
    console.log(this.statusstring);
    this.submitform();
  }
  submitform() {
    const payload = {
      checkeremark: this.checker1remark,
      id: this.toolid
    }
    if (this.statusstring == 'approve') {

      console.log('api required');
      console.log(payload, 'done data');
      let formdata = new FormData();
      formdata.append('ToolLoanDetailIds',this.toolid),
      formdata.append('ApprovedRemark',this.checker1remark)
      this._apiService.healthcheckupapprove(formdata).then((res: any) => {
        this.checker1Modal = false
        this._utility.loader(true)
        if (res.success) {
          this.checker1Modal = false
          this._utility.loader(false)
          console.log(res);
          this.checker1remark = ''
        }
        else {
          console.log('else');
          this._apiService.showMessage(res.message, "error");
        }
      })
        .catch((error) => {
          this.checker1Modal = false
          this._utility.loader(false)
          console.error('API error:', error);
          this._apiService.showMessage("Something went wrong. Please try again.", "error");
        });
    }
    else if (this.statusstring == 'reject') {
      let formdata = new FormData();
      formdata.append('ToolLoanDetailIds',this.toolid),
      formdata.append('RejectedRemark',this.checker1remark)
      this._apiService.healthcheckupreject(formdata).then((res: any) => {
        if (res.success) {
          this.checker1remark = ''
        }
        else {
          console.log('else');
          this._apiService.showMessage(res.message, "error")
        }
      })
        .catch((error) => {
          console.log('api error', error);
          this._apiService.showMessage("Something went wrong. Please try again.", "error");
        })
      console.log(payload, 'rejected data');
      console.log('rejected');
    }
  }
  openmodal(id){
    console.log(id);
    this.display=true;
    const matchedItem = this.ToolListData.find(item => item.toolLoanDetailId === id);
    this.healthcheckupdetails = [matchedItem];
  }
}
